export const ApiCheckInCheckOut = {
  orgActivitiesValidate: `public/v1/volunteer-org/attendances/validate`,
  individualActivitiesValidate: 'public/v1/sessions/volunteer/activities/validate',
  individualActivitiesCenterValidate: 'public/v1/volunteer/activity/center',
  attendanceValidation: `public/v1/volunteer/attendance/validate`,
  attendanceCheckIn: `public/v1/volunteer/attendance/check-in`,
  attendanceCheckOut: `public/v1/volunteer/attendance/check-out`,
  attendanceOrgCheckIn: `public/v1/volunteer-org/attendances/check-in`,
  attendanceOrgCheckOut: `public/v1/volunteer-org/attendances/check-out`,
  searchOrganization: `public/v1/volunteer-org/search`,
  getEventListByCenterAndOrg: `public/v1/volunteer-org/attendance/validate`,

  // for AAC
  aacValidateQr: (sessionId: string) => `public/v1/sessions/${sessionId}/validate-qr-aap`,
  aacRegistration: (sessionId: string) => `public/v1/sessions/${sessionId}/validate-aap-registration`,
  aacCheckIn: (sessionId: string) => `public/v1/sessions/${sessionId}/check-in`,
  aacCheckOut: (sessionId: string) => `public/v1/sessions/${sessionId}/check-out`
};
